import * as types from 'store/modules/hres7fe/mutation-types'
import hres7fe from 'api/hres7fe'
import stdtrtest from 'api/stdtrtest'
import swal from 'sweetalert'
import hres7feLabels from 'assets/labels/hres7fe'
import { hres7feColumns } from 'assets/columns/hres7fe'
import configLabel from 'src/../config/label'
import axios from 'axios'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hres7feLabels,
    columns: hres7feColumns(),
    indexSelected: {},
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {
        detail: {},
        table1: {
          total: 0,
          rows: []
        },
        table2: {
          total: 0,
          rows: []
        }
      },
      tab2: {}
    }
  },
  getters: {
    [types.GET_HRES7FE_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES7FE_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES7FE_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES7FE_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES7FE_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES7FE_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES7FE_DETAIL] (state) {
      return state.detail
    }
  },
  mutations: {
    [types.SET_HRES7FE_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES7FE_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES7FE_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
      }
    },
    [types.SET_HRES7FE_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES7FE_INDEX] (state, index) {
      state.index = index
    },
    [types.SET_HRES7FE_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES7FE_DETAIL] (state, detail) {
      state.detail = detail
    }
  },
  actions: {
    [types.TOGGLE_HRES7FE_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES7FE_INDEX_DISP, indexDisp)
      commit(types.SET_HRES7FE_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES7FE_COLUMNS_LABELS] ({ commit }) {
      axios.all([
        hres7fe.getLabels(),
        stdtrtest.getLabels()
      ])
      .then(axios.spread(function (responseLabels, responseLabelsStdtrtest) {
        const dataHres7fe = JSON.parse(responseLabels.request.response)
        const dataStdtrtest = JSON.parse(responseLabelsStdtrtest.request.response)
        let labels = {}
        labels.en = Object.assign(dataHres7fe.labels.en, dataStdtrtest.labels.en)
        labels.th = Object.assign(dataHres7fe.labels.th, dataStdtrtest.labels.th)
        commit(types.SET_HRES7FE_COLUMNS, labels)
        commit(types.SET_HRES7FE_LABELS, labels)
      }))
      .catch((error) => {
        let message = error
        if (error.response) {
          const data = error.response.data
          message = data.response
        }
        swal({
          title: '', text: message, html: true, type: 'error'
        }, function () {
          window.onkeydown = null; window.onfocus = null; swal('')
        })
      })
    },
    [types.RECEIVED_HRES7FE_INDEX] ({ commit }, searchParams) {
      hres7fe.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES7FE_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES7FE_DETAIL] ({ commit }, searchParams) {
      hres7fe.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES7FE_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRES7FE_TAB1_SAVE] ({ commit, dispatch }, { searchIndex, indexSelected, detailTab1 }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: 'ok',
        cancelButtonText: 'cancel',
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hres7fe.postSaveDetailTab1({ searchIndex, indexSelected, detailTab1 })
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRES7FE_INDEX, searchIndex)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRES7FE_TAB2_SAVE] ({ commit, dispatch }, { searchIndex, indexSelected, detailTab2 }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: 'ok',
        cancelButtonText: 'cancel',
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hres7fe.postSaveDetailTab2({ searchIndex, indexSelected, detailTab2 })
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRES7FE_INDEX, searchIndex)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres7fe/index.js